import React from 'react';
import styled from '../../../components/styled';

import { Snippet } from '../../../services/dataModels';
import RollupDetailsCard from '../RollupDetailsCard';

interface HeaderProps {
  snippet: Snippet;
  rollupIndex?: number;
}

const Header = ({ snippet, rollupIndex }: HeaderProps) => {
  switch (snippet.type) {
    case 'RollupComment':
    case 'RollupDataEntryTable':
    case 'RollupMatrix':
      return (
        <Container>
          <RollupDetailsCard rollupDetails={snippet.data[rollupIndex].rollupDetails} />
        </Container>
      );
    case 'Table': {
      const isLocal = snippet.isEdited;
      return (
        <Container>
          <TableWarning>
            <TableWarningKey>State:</TableWarningKey>
            <TableWarningValue>{isLocal ? 'Local' : 'Remote'}</TableWarningValue>
          </TableWarning>
        </Container>
      );
    }
    default:
      return <></>;
  }
};

const Container = styled.View`
  background: white;
`;

const TableWarning = styled.View`
  padding-vertical: 5px;
  padding-horizontal: 18px;
  flex-direction: row;
`;

const TableWarningKey = styled.Text`
  font-weight: bold;
  margin-right: 5px;
`;

const TableWarningValue = styled.Text``;

export default Header;
